import { styled } from "@mui/material";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { AutocompleteStyle } from "../../../Utils/MuiStyles/AutocompleteStyles";
import useLang from "Shared/hooks/useLanguage";
import CompendiumPanelMappingIndex from "./PanelMapping";
import { NavCompendium } from "./NavCompendium";
import CompendiumTestIndex from "./Test";
import { NavCompendiumTest } from "./NavCompendiumTest";

const TabSelected = styled(Tab)(AutocompleteStyle());
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const PGXCompendiumData: React.FC<{}> = () => {
  const { t } = useLang();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [refresh, setRefresh] = React.useState(false);
  const [refreshTest, setRefreshTest] = React.useState(false);
  return (
    <>
      {value === 0 && (
        <NavCompendium setRefresh={setRefresh} refresh={refresh} />
      )}

      {value === 1 && (
        <NavCompendiumTest
          setRefreshTest={setRefreshTest}
          refreshTest={refreshTest}
        />
      )}

      <div className="d-flex flex-column flex-column-fluid">
        <div className="app-content flex-column-fluid">
          <div className="app-container container-fluid">
            <Tabs
              value={value}
              onChange={handleChange}
              TabIndicatorProps={{ style: { background: "transparent" } }}
              className="min-h-auto"
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                "& .MuiTabs-scrollButtons": {
                  width: 0,
                  transition: "width 0.7s ease",
                  "&:not(.Mui-disabled)": {
                    width: "48px",
                  },
                },
              }}
            >
              <TabSelected
                label={t("Panel Mapping")}
                {...a11yProps(0)}
                className="fw-bold text-capitalize"
                id={`CompendiumPanelMapping`}
              />
              <TabSelected
                label={t("Test")}
                {...a11yProps(1)}
                className="fw-bold text-capitalize"
                id={`CompendiumTest`}
              />
            </Tabs>
            <div className="card rounded-top-0 shadow-none tab-content-card">
              <div className="card-body py-2">
                <TabPanel value={value} index={0}>
                  <CompendiumPanelMappingIndex refresh={refresh} />
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <CompendiumTestIndex refreshTest={refreshTest} />
                </TabPanel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PGXCompendiumData;
